const WINDOWS_ABSOLUTE_PATH_RE =
  /(?:[A-Z]:[\\/](?:[^\\/:*?"<>|\r\n]+[\\/])*[^\\/:*?"<>|\r\n]+)/gi;

const UNIX_ABSOLUTE_PATH_RE = /\/(?:[^/\s:\r\n]+\/)+[^/\s:\r\n]+/g;

export const sanitizeVisibleText = (text = '') =>
  text
    .replace(WINDOWS_ABSOLUTE_PATH_RE, '[path]')
    .replace(UNIX_ABSOLUTE_PATH_RE, '[path]');
